import { createContext } from 'react';

import type { TickAxis } from '../../../core/utils/formatter-by-ticks.js';

export interface XYChartAxesTicksProps {
  topTicks: TickAxis;
  bottomTicks: TickAxis;
  leftTicks: TickAxis;
  rightTicks: TickAxis;
}

export const XYChartAxesTicksContext = createContext<
  XYChartAxesTicksProps | undefined
>(undefined);
